import { useQuery } from '@tanstack/react-query';

import apiHelper from '@/apiHelper';
import { NookUpdatesResponse } from '@/types/nook';

const POLLING_INTERVAL = 10000;

export function useCheckUpdatesQuery(nookId: string, currentVersion: number) {
  return useQuery({
    queryKey: ['nook', nookId, 'updates'],
    queryFn: async (): Promise<NookUpdatesResponse> => {
      const response = await apiHelper.get(
        `/api/nook/updates/${nookId}?lastKnown=${currentVersion}`
      );
      return response.data?.data;
    },
    refetchInterval: POLLING_INTERVAL,
    refetchOnWindowFocus: false,
    enabled: !!nookId && currentVersion > 0,
  });
}

export default useCheckUpdatesQuery;
